<template>
  <div id="home">
    <div style="width: 100%;height: 40px"></div>
    <div class="c-loading" v-if="loading">
      <div class="c-loading-c">
        <img src="../assets/loading.svg">
        <div>加载中...</div>
      </div>

    </div>

    <div class="video-content" v-else>

      <div class="video_placeholder" :style="{height:video_height+'px'}">


        <video width="100%" :style="{height:video_height+'px'}" :poster="data.cover" controls="controls" preload="meta" x-webkit-airplay="true" webkit-playsinline="true" playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" :src="data.play_url"><source src="" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="content">
        <div class="content-title">{{data.movie_name}}</div>
        <div class="content-text font-nomal" v-html="TextAreaText2Html(data.movie_desc)"></div>
        <div class="content-text font-nomal" >{{data.publish_time}}</div>
      </div>

      <a href="http://img2.yitoutiao.net/app/download.html" class="bottom_btn_">打开APP查看更多精彩评论</a>
    </div>


  </div>
</template>
<style scoped>
  .content-title{ font-size: 18px; color: #323232; padding: 15px 0; font-weight: bold;  padding-bottom: 10px; line-height: 24px; text-align: justify}
  .content-title span{ vertical-align: middle}
  .content-text{ font-size: 12px; color: #8e8e8e; line-height: 18px;text-align: justify}
  .bottom_btn_ {
    display: block;
    width: 15rem;
    margin: 0.6rem auto;
    border-radius: 1rem;
    text-align: center;
    color: #fff;
    background: #ee1a1a;
    bottom: 2.45rem;
    padding: 0.3rem 0.4rem;
    font-size: 1rem;
  }
</style>
<script>
// @ is an alias to /src
import layVideo from '@/components/Video.vue'
import request from "../utils/request";
import utils from "../utils";

export default {
  name: 'defaultVideoContent',
  data(){
    return {
      id:this.$route.params.id,
      data:{
        cover:"",
        play_url:"",
        movie_name:""
      },
      video_height:200

    }
  },
  components: {
    layVideo
  },
  created() {
    this.getdata();
    try{
      document.querySelector(".toplink").style.display = 'block';
    }catch (e) {

    }
  },
  mounted() {
    this.video_height=w/(16/9);
    document.querySelector(".toplink").style.display = 'block';
  },
  methods:{
    TextAreaText2Html: function TextAreaText2Html(text) {
      return utils.TextAreaText2Html(text);
    },
    getdata(){
      request.getVideoInfo(this.id,(res)=>{
        this.loading = false;
        if(res && res.code===200){
          this.data = res.data;
          request.getWeixinShanre(location.href,(s_res)=>{
            let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
            let shareconfig = {appId,timestamp,nonceStr,signature};
            if(utils.is_weixin()){
              if(res.data){
                let sharedata = {
                  title:res.data.movie_name,
                  desc:res.data.movie_desc?res.data.movie_desc:"看度时政",
                  link:location.href,
                  imgUrl:thumb
                };
                utils.setWeiXinShare(sharedata,shareconfig,false)
              }

            }
          });


        }
      })
    }
  }
}
</script>
